import FaiBox from "../MuiComponents/FaiBox";

import Home from "../screens/Home";

import Inventory from "../screens/Catalog/Inventory";
import InventoryApproval from "../screens/Catalog/Inventory/Approval/ApprovalProductDetails";
import InventoryRejected from "../screens/Catalog/Inventory/Rejected/RejectedProductDetails";
import AddProduct from "../screens/Catalog/AddProductForm";

import Reports from "../screens/Reports";
import Staff from "../screens/Staff";

import HelpAndSupport from "../screens/HelpAndSupport/RaisedIssues";

import Customer from "../screens/Customer";
// import FeedbackDetails from "../screens/Customer/FeedbackDetails";

// import CouponList from "../screens/Promotions/Coupons";
// import CouponForm from "../screens/Promotions/CouponForm";
// import Sales from "../screens/Promotions/Sales";
import SalesDetails from "../screens/Promotions/Sales/component/SalesDetails";

import Orders from "../screens/OrdersAndReturns/Orders";
import Returns from "../screens/OrdersAndReturns/Returns";
import Refunds from "../screens/OrdersAndReturns/Refunds";

import Payments from "../screens/Payments";
import OnBoarding from "../screens/OnBoarding";
import Drafts from "screens/Catalog/Draft";
import Category from "screens/Category";
import MerchantOnboarding from "screens/MerchantOnboarding";
// import Promotions from "screens/Promotions";
import CouponList from "screens/Promotions/Coupons";
import Sales from "screens/Promotions/Sales";

const routes = [
	{
		type: "collapse",
		name: "Home",
		key: "home",
		route: "/app/home",
		component: <Home />,
		noCollapse: true,
	},
	{
		type: "collapse",
		name: "Merchant Onboarding",
		key: "merchant-onboarding",
		route: "/app/merchant-onboarding",
		component: <MerchantOnboarding />,
		noCollapse: true,
	},
	{
		type: "collapse",
		name: "On Boarding",
		key: "onboarding",
		icon: (
			<FaiBox
				component="i"
				color="inherit"
				fontSize="14px"
				className="ni ni-align-left-2"
			/>
		),

		collapse: [
			{
				name: "Basic Details",
				key: "basicDetails",
				route: "onboarding/basicDetails",
				component: <OnBoarding />,
			},
			{
				name: "Business Details",
				key: "businessdetails",
				route: "onboarding/businessdetails",
				component: <OnBoarding />,
			},
			{
				name: "Brand Details",
				key: "brandDetails",
				route: "onboarding/brandDetails",
				component: <OnBoarding />,
			},
			{
				name: "Bank Details",
				key: "bankdetails",
				route: "onboarding/bankdetails",
				component: <OnBoarding />,
			},
		],
	},
	{
		type: "collapse",
		name: "Orders",
		key: "orderandreturns",
		collapse: [
			{
				name: "Order",
				key: "order",
				route: "/app/orderandreturns/order",
				component: <Orders />,
			},
			{
				name: "Returns",
				key: "return",
				route: "/app/orderandreturns/return",
				component: <Returns />,
			},
			{
				name: "Refunds",
				key: "refund",
				route: "/app/orderandreturns/refund",
				component: <Refunds />,
			},
		],
	},
	{
		type: "collapse",
		name: "Tickets",
		key: "tickets",
		collapse: [
			{
				name: "All Tickets",
				key: "ongoing",
				route: "/app/tickets/ongoing",
				component: <HelpAndSupport />,
			},
		],
	},

	{
		type: "collapse",
		name: "Customer",
		key: "customer",
		route: "/app/customer",
		component: <Customer />,
		noCollapse: true,
	},
	// {
	// 	type: "collapse",
	// 	name: "Promotions",
	// 	key: "promotions",
	// 	route: "/app/promotions/Coupons",
	// 	component: <Promotions />,
	// 	noCollapse: true,
	// },
	{
		type: "collapse",
		name: "Promotions",
		key: "promotions",
		collapse: [
			{
				name: "Coupons",
				key: "Coupons",
				route: "/app/promotions/Coupons",
				component: <CouponList />,
			},
			{
				name: "Sales",
				key: "sales",
				route: "/app/promotions/sales",
				component: <Sales />,
			},
		],
	},
	{
		type: "",
		name: "Sales Details",
		key: "salesDetails",
		route: "/app/promotions/sales/:salesId",
		component: <SalesDetails />,
		noCollapse: true,
	},

	{
		type: "collapse",
		name: "Payments",
		key: "payments",
		route: "/app/payments",
		component: <Payments />,
		noCollapse: true,
	},

	{
		type: "collapse",
		name: "Category",
		key: "category",
		route: "/app/category",
		component: <Category />,
		noCollapse: true,
	},
	{
		type: "collapse",
		name: "Reports",
		key: "reports",
		route: "/app/reports",
		component: <Reports />,
		noCollapse: true,
	},
	{
		type: "collapse",
		name: "Help-desk Access",
		key: "staff",
		route: "/app/staff",
		component: <Staff />,
		noCollapse: true,
	},

];

// A help-desk account sees only the tickets (the backend refuses everything else anyway).
export const routesFor = (helpDesk: boolean) => (helpDesk ? routes.filter((r: any) => r.key === "tickets") : routes);
export const homeFor = (helpDesk: boolean) => (helpDesk ? "/app/tickets/ongoing" : "/app/home");

export default routes;
